"use client"

import { getPlanDisplayPricing, type PricingCurrency } from "../config/plans"
import { HALLOWEEN_COUPON_CODE, isHalloweenCoupon } from "../payments/halloween-offer"
import { useCheckoutCoupon } from "./use-checkout-coupon"
import { useLogger } from "./use-logger"

/** Campaign prices come from the same server validation used at checkout. */
export function useHalloweenPricing(requestedCoupon: string | null, currency: PricingCurrency) {
  const logger = useLogger()
  const requested = isHalloweenCoupon(requestedCoupon)
  const monthly = getPlanDisplayPricing("monthly", currency)!
  const yearly = getPlanDisplayPricing("yearly", currency)!
  const monthlyQuote = useCheckoutCoupon({
    selectedPlan: "monthly",
    pricingCurrency: currency,
    orderValue: monthly.originalAmount ?? monthly.amount,
    promoCode: requested ? HALLOWEEN_COUPON_CODE : "",
    logger,
  })
  const yearlyQuote = useCheckoutCoupon({
    selectedPlan: "yearly",
    pricingCurrency: currency,
    orderValue: yearly.originalAmount ?? yearly.amount,
    promoCode: requested ? HALLOWEEN_COUPON_CODE : "",
    logger,
  })
  return (plan: string) =>
    !requested ? null : plan === "monthly" ? monthlyQuote : plan === "yearly" ? yearlyQuote : null
}
